export default `# Projects

Projects are the top-level container for all your work in Spectrum. Each project brings together sessions, research, requirements, and integrations into one workspace.

---

## Dashboard Overview

The projects dashboard shows all your projects in a searchable table. Each row displays:

- **Project name** and description
- **Status** — Active or Archived
- **Session count** — How many sessions are linked
- **Document count** — Files and assets attached
- **Last activity** — When someone last worked in the project

Use the **search bar** to find projects by name or description, and the **status filters** (Active / All / Archived) to narrow the list.

---

## Creating a Project

Click **New Project** in the top-right corner to open the creation dialog. Give your project a name and description — you can always update these later.

Once created, click the project row to open its detail page where you can configure sessions, research, and integrations.

---

## Project Lifecycle

Projects start as **Active** and can be **Archived** when work is complete. Archived projects are hidden by default but can be restored at any time.

---

## Tips

- **Link sessions to projects** — Sessions created within a project automatically share context, making AI outputs more relevant
- **Use the knowledge graph** — As you run sessions, entities (personas, stories, decisions) accumulate in the project graph, revealing patterns across sessions
- **Check last activity** — If a project hasn't been touched recently, it may be a candidate for archiving`;
